module.exports = __webpack_public_path__ + "static/media/ChestGreen.c3a3e8d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online-assets/sprites/ChestGreen.png
// module id = 2749
// module chunks = 0